import { Injectable } from '@angular/core';
import { Constants } from 'src/app/app.constants';
import { AlertService } from 'src/app/core/alert.service';
import { HttpRequestType, RequestService } from 'src/app/core/request.service';
import { BaseService } from 'src/app/shared/base/base.service';
import { DashboardParam, Dashboard } from './dashboard.models';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends BaseService {

  constructor(protected requestService: RequestService, private alertService: AlertService) {
    super(requestService);
  }

  getDashboard(params: DashboardParam = new DashboardParam(), onSuccess: Function) {
    this.requestService.createRequest(HttpRequestType.Post, `${Constants.contextPath}/dashboard`, params, null, (response: Dashboard[]) => {

      let dashboard = [];
      for (let d of response) {
        dashboard[d.dashboardGraphType] = {
          show: true,
          ...d
        };
      }

      onSuccess(dashboard);
    })
  }

  generateSitemap() {
    this.requestService.createRequest(HttpRequestType.Post, `${Constants.contextPath}/sitemap`, null, null, () => {
      this.alertService.success('SITEMAP.GENERATED')
    })
  }
}
